import { validate } from 'jsonschema';
import { compose } from 'redux';
import { equals, path } from 'ramda';

import schema from 'config/config-delta.schema.json';

const validateConfig = config => validate(config, schema);

const isDeltaConfigValid = compose(
  equals(0),
  path(['errors', 'length']),
  validateConfig,
);

export { isDeltaConfigValid, validateConfig };
